import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Qué formato tiene el material?',
  a: 'Es un producto digital descargable en PDF, listo para imprimir o editar.'
}, {
  q: '¿Puedo usarlo en cualquier nivel educativo?',
  a: 'Sí, las actividades son adaptables a primaria y secundaria.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de la compra, recibirás el enlace de descarga por email.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí, tenés 7 días de garantía. Si no te sirve, te devolvemos el 100% de tu dinero.'
}, {
  q: '¿Puedo compartirlo con otros docentes?',
  a: 'El material es de uso personal. Cada docente debería tener su propia licencia.'
}, {
  q: '¿Funciona para escuelas con poco espacio?',
  a: '¡Sí! El Bono 3 está diseñado específicamente para espacios reducidos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-white" data-id="element-47">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-48">
        <div className="text-center mb-12" data-id="element-49">
          <HelpCircle className="w-12 h-12 text-[#1B5E20] mx-auto mb-4" data-id="element-50" />
          <h2 className="text-3xl font-black text-[#0F172A]" data-id="element-51">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-52">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-53">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-54">
                <span className="font-bold text-gray-800 text-lg" data-id="element-55">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-[#1B5E20]" data-id="element-56" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-57" />}
              </button>

              <AnimatePresence data-id="element-58">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-59">
                    <div className="p-5 bg-white text-gray-600 border-t border-gray-100" data-id="element-60">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}